<section [class]="bgClass">
    <div class="width-container">
        <h1 [innerHtml]="'BANNER.HEAD' | translate"></h1>
    </div>
    <div class="width-container">
        @if(data.REG_DATE == undefined) {
            <img [src]="assetsUrl + 'cards/MileagePlus_Card_Generic_Visa.png'" alt="United MilesagePlus Card"/>
        } @else {
            <img [src]="'CONFIRM.CARD_IMG' | translate:data"  alt="United MilesagePlus Card"/>
        }

    </div>
</section>